import FirestoreContext from './FirestoreContext';

export default FirestoreContext.Consumer;
